(() => {
  if (window.MELDrawerFormsReady) return;
  window.MELDrawerFormsReady = true;
  document.addEventListener('click', async event => {
    const link=event.target.closest?.('a[href]');const drawer=document.getElementById('CartDrawer');
    if(!link||!drawer||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||link.target==='_blank'||!link.closest('.mel-site-chrome--header'))return;
    if(new URL(link.href,location.href).pathname!=='/cart')return;
    event.preventDefault();await drawer.onCartRefresh({detail:{open:true}});
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.mel-product-form')) return;
    if (event.submitter?.closest('.shopify-payment-button')) return;
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (form.dataset.drawerBusy) return;
    form.dataset.drawerBusy = 'true';
    const button = event.submitter || form.querySelector('[type=submit]');
    const oldDisabled = button?.disabled;
    if (button) button.disabled = true;
    try {
      await customElements.whenDefined('cart-drawer');
      drawer.setAttribute('aria-busy','true');drawer.show(button);
      const data = new FormData(form);
      data.set('sections', drawer.sectionId); data.set('sections_url', location.pathname);
      const response = await fetch((window.theme?.routes?.cart_add_url || '/cart/add.js'), {method:'POST',body:data,headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item');
      const parsed = new DOMParser().parseFromString(result.sections?.[drawer.sectionId] || '', 'text/html');
      const id = 'MiniCart-' + drawer.sectionId;
      const target = document.getElementById(id), updated = parsed.getElementById(id);
      if (target && updated) { target.innerHTML = updated.innerHTML; drawer.show(button); }
      else await drawer.onCartRefresh({detail:{open:true}});
      const cart = await (await fetch('/cart.js',{cache:'no-store'})).json();
      document.querySelectorAll('[data-cart-count],.cart-count,.mel-cart-count').forEach(node=>{ node.textContent=String(cart.item_count); node.hidden=!cart.item_count; });
      form.dispatchEvent(new CustomEvent('mel:cart-added',{bubbles:true,detail:{cart}}));
    } catch (error) {
      let status=form.querySelector('[data-mel-drawer-error]');
      if(!status){status=document.createElement('p');status.dataset.melDrawerError='';status.setAttribute('role','alert');form.append(status);}
      status.textContent=error.message;
    } finally { drawer.removeAttribute('aria-busy');delete form.dataset.drawerBusy; delete form.dataset.submitting;form.removeAttribute('aria-busy');if(button)button.disabled=oldDisabled; }
  },true);
})();
